import { Controller } from 'react-hook-form'
import CountrySearch from '../../../Common/CountrySearch'
import { usePatientFormContext } from '../../context/PatientFormContext'

import { validateBirthPlaceAndSsnMatching } from '../../../../utils/validators'
import { patientFormCountryBirthErrors } from '../../_errors'
import PatientFormField from '../PatientFormField'
import { useFormContextPatient } from '../_utils'
import { shouldDirty } from '../PatientIdentity/_utils/_utils'

const CountryBirth = () => {
    const { control, setValue, setError, clearErrors, watch } = useFormContextPatient()
    const {
        state: { isDisabled },
    } = usePatientFormContext()

    return (
        <Controller
            control={control}
            name="countryBirth"
            rules={{
                required: true,
                validate: (val) => {
                    const watchedInsNum = watch('insNum')
                    if (val && watchedInsNum && watchedInsNum.trim().length > 0) {
                        const validationErrors = validateBirthPlaceAndSsnMatching(val.inseeCode || 100, watchedInsNum)

                        const errorResult = Boolean((validationErrors?.length ?? 0) === 0)
                        return validationErrors.length > 0
                            ? validationErrors.map((err) => (err ? patientFormCountryBirthErrors[err] : '')).join('. ')
                            : errorResult
                    }
                    return true
                },
            }}
            render={({ field, fieldState: { error } }) => {
                const initialValue = field.value ?? undefined

                return (
                    <PatientFormField
                        variant="custom"
                        label="Pays de naissance"
                        name={field.name}
                        disabled={isDisabled}
                        status={{
                            error,
                            valid: Boolean(field.value),
                        }}
                        required
                        render={() => (
                            <CountrySearch
                                label="Recherche par nom du pays"
                                onCountrySearchChange={(country) => {
                                    if (country) {
                                        if (country.name.toUpperCase() !== 'FRANCE') {
                                            setValue('birthCityCode', null, shouldDirty)
                                            setValue('birthCityLabel', null, shouldDirty)
                                            setValue('birthCity', null, shouldDirty)
                                        }
                                        setValue('countryBirth', country, shouldDirty)
                                        clearErrors('countryBirth')
                                    }
                                }}
                                onSearchValueChange={(search) => {
                                    if (!search) {
                                        setError('countryBirth', {
                                            message: '',
                                        })
                                    }
                                }}
                                onBlur={() => {
                                    if (!field.value) {
                                        setError('countryBirth', {
                                            message: 'Le pays de naissance est obligatoire et n’a pas été renseigné',
                                        })
                                    }
                                }}
                                initialValue={initialValue}
                                error={false}
                                disabled={isDisabled}
                            />
                        )}
                    />
                )
            }}
        />
    )
}

export default CountryBirth
